import { BrowserRouter } from "react-router-dom";
import PageRoute from "./routes";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Toaster } from "react-hot-toast";
import { MenuProvider } from "./Context/MenuContext";

function App() {
  return (
    <>
      {window.navigator.onLine === false ? (
        <LazyLoadImage
          src="/assets/Offline.png"
          style={{ width: "80%", marginLeft: "10%" }}
          draggable="false"
        />
      ) : (
        <BrowserRouter>
          <MenuProvider>
            <PageRoute />
            <Toaster />
          </MenuProvider>
        </BrowserRouter>
      )}
    </>
  );
}

export default App;